import React, { memo } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Box } from '@chakra-ui/react';
import { RiVerifiedBadgeFill } from 'react-icons/ri';


function VerifiedUserTag({isVerified, paidFeatureAccess}) {
  if (isVerified === true && !!paidFeatureAccess) {
   return (
    <Box as='span'>
      <Box as={RiVerifiedBadgeFill} boxSize='1em' color='brand.500' ml='0.5em' />
    </Box>
   )
  } else return null;
}


const mapStateToProps = (state) => ({
  paidFeatureAccess: state.userPrivileges.results.paidFeatureAccess,
})


export default memo(withRouter(connect(mapStateToProps, null)(VerifiedUserTag)))